<div class="blocklist-page">
    <header class="page-header">
        <div class="page-header__inner">
            <div class="page-header__left">
                <button type="button" class="icon-button" (click)="goBack()" aria-label="Zurück">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <img src="/copago-logo.png" alt="Copago Logo" class="brand-logo" />
            </div>

            <div class="page-header__center">
                <div class="page-title">Reservierungsnamen Sperrliste</div>
                <div class="page-subtitle">Unzulässige Begriffe für Reservierungsnamen verwalten</div>
            </div>

            <div class="page-header__right">
                <button type="button" class="icon-button" (click)="logout()" aria-label="Logout">
                    <mat-icon>logout</mat-icon>
                </button>
            </div>
        </div>
    </header>

    <main class="page-content">
        <section class="content-wrapper">
            <div class="form-card">
                <div class="form-title">
                    {{ editingId ? 'Eintrag bearbeiten' : 'Neuen Eintrag hinzufügen' }}
                </div>

                <div class="form-grid">
                    <label class="app-field">
                        <span>Name</span>
                        <input type="text" [(ngModel)]="name" name="name" autocomplete="off" placeholder="Name" />
                    </label>

                    <label class="app-field">
                        <span>Beschreibung</span>
                        <input type="text" [(ngModel)]="description" name="description" autocomplete="off"
                            placeholder="Beschreibung optional" />
                    </label>

                    <div class="form-actions">
                        <button class="primary-action" type="button" (click)="save()" [disabled]="isSaving">
                            {{ editingId ? 'Speichern' : 'Hinzufügen' }}
                        </button>

                        <button class="secondary-action" type="button" (click)="resetForm()" [disabled]="isSaving">
                            Zurücksetzen
                        </button>
                    </div>
                </div>

                <div class="error-box" *ngIf="error">
                    {{ error }}
                </div>
            </div>

            <div class="table-card">
                <div class="table-header">
                    <div>
                        <h2>Sperrliste</h2>
                        <p>{{ filteredItems.length }} von {{ items.length }} Einträge</p>
                    </div>

                    <div class="blocklist-search-box">
                        <mat-icon>search</mat-icon>
                        <input type="text" placeholder="Name suchen..." [(ngModel)]="searchTerm" />
                    </div>

                    <button type="button" (click)="loadItems()" [disabled]="isLoading">
                        Aktualisieren
                    </button>
                </div>

                <div class="loading-state" *ngIf="isLoading">
                    <mat-spinner diameter="36"></mat-spinner>
                    <span>Daten werden geladen ...</span>
                </div>

                <div class="empty-state" *ngIf="!isLoading && !filteredItems.length">
                    Keine passenden Einträge gefunden.
                </div>

                <div class="blocklist-table" *ngIf="!isLoading && filteredItems.length">
                    <div class="blocklist-table__head">
                        <button type="button" class="sortable-header" (click)="toggleSort('name')">
                            <span>Name</span>
                            <mat-icon>{{ getSortIcon('name') }}</mat-icon>
                        </button>

                        <div>Beschreibung</div>

                        <button type="button" class="sortable-header" (click)="toggleSort('createdAt')">
                            <span>Erstellt</span>
                            <mat-icon>{{ getSortIcon('createdAt') }}</mat-icon>
                        </button>

                        <div>Aktualisiert</div>
                        <div class="align-center">Aktionen</div>
                    </div>

                    <div class="blocklist-table__row" *ngFor="let item of filteredItems; trackBy: trackById">
                        <div class="name-cell">{{ item.name }}</div>
                        <div class="description-cell">{{ item.description || '—' }}</div>
                        <div>{{ formatDate(item.createdAt) }}</div>
                        <div>{{ formatDate(item.lastUpdatedAt) }}</div>

                        <div class="actions-cell">
                            <button type="button" class="table-icon-button" (click)="edit(item)"
                                aria-label="Bearbeiten">
                                <mat-icon>edit</mat-icon>
                            </button>

                            <button type="button" class="table-icon-button table-icon-button--danger"
                                (click)="openDeleteConfirm(item)" aria-label="Löschen">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>

    <div class="confirm-backdrop" *ngIf="itemToDelete">
        <div class="confirm-dialog">
            <div class="confirm-icon">
                <mat-icon>warning</mat-icon>
            </div>

            <div class="confirm-content">
                <h3>Eintrag löschen?</h3>

                <p>
                    Möchtest du den Begriff
                    <strong>„{{ itemToDelete.name }}“</strong>
                    wirklich aus der Sperrliste entfernen?
                </p>

                <p class="confirm-hint">
                    Danach wird dieser Begriff nicht mehr für Reservierungsnamen blockiert.
                </p>
            </div>

            <div class="confirm-actions">
                <button type="button" class="confirm-secondary" (click)="closeDeleteConfirm()" [disabled]="isDeleting">
                    Abbrechen
                </button>

                <button type="button" class="confirm-danger" (click)="confirmDelete()" [disabled]="isDeleting">
                    {{ isDeleting ? 'Wird gelöscht ...' : 'Ja, löschen' }}
                </button>
            </div>
        </div>
    </div>
</div>